import { type MouseEventHandler, useState } from 'react';

// ** MUI Components
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import ToggleButton, { type ToggleButtonProps } from '@mui/material/ToggleButton';

// ** Components
import Typography from '@mui/material/Typography';
import { readUserScopedItem, userScopedStorage } from '@erikdakoda/ui/shared/userScopedStorage';

const TextSizeToggler = (props: Partial<ToggleButtonProps>) => {
  'use memo';

  const [textSize, setTextSize] = useState(readUserScopedItem('textSize') || '17px');

  const handleChange = (event: React.MouseEvent<HTMLElement>, textSize: string) => {
    userScopedStorage.setItem('textSize', textSize);
    setTextSize(textSize);
    // @ts-expect-error
    document.getElementsByTagName('html')[0].style.fontSize = textSize;
  };

  const handleClick: MouseEventHandler<HTMLDivElement> = (event) => {
    event.stopPropagation();
  };

  return (
    <ToggleButtonGroup
      color="secondary"
      value={textSize}
      exclusive
      onChange={handleChange}
      // @ts-expect-error
      onClick={handleClick}
      aria-label="Text size"
      size="small"
      {...props}
    >
      <ToggleButton value="13px">
        <Typography
          sx={{
            color: 'inherit',
            lineHeight: 0.8,
            fontSize: '13px',
          }}
        >
          A
        </Typography>
      </ToggleButton>
      <ToggleButton value="15px">
        <Typography
          sx={{
            color: 'inherit',
            lineHeight: 0.8,
            fontSize: '14px',
          }}
        >
          A
        </Typography>
      </ToggleButton>
      <ToggleButton value="17px">
        <Typography
          sx={{
            color: 'inherit',
            lineHeight: 0.8,
            fontSize: '16px',
          }}
        >
          A
        </Typography>
      </ToggleButton>
      <ToggleButton value="19px">
        <Typography
          sx={{
            color: 'inherit',
            lineHeight: 0.8,
            fontSize: '19px',
          }}
        >
          A
        </Typography>
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

export default TextSizeToggler;
